<template>
  <div id="container">
      <Spinner :show="loading"></Spinner>
      <Header></Header>
      <section ref="content" id="content" class="section">
          <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
          <h4 v-if="!transactions.length" class="title is-size-4 has-text-centered">{{ $t("NoWalletTransactions") }}</h4>
          <table v-if="transactions.length" class="table is-bordered is-fullwidth is-size-7">
              <thead>
                  <tr>
                      <th>{{ $t("Date") }}</th>
                      <th>{{ $t("Amount") }}</th>
                  </tr>
              </thead>
              <tbody>
                  <template v-for="transaction in transactions">
                    <tr :key="transaction.transactionID" class="thick-border-top">
                        <td>{{ transaction.date }}</td>
                        <td>{{ transaction.amount }}</td>
                    </tr>
                    <tr :key="transaction.tranasctionDate">
                        <td colspan="3"><i v-html="transaction.description"></i></td>
                    </tr>
                  </template>
              </tbody>
          </table>
          <div v-show="allowedUsers" class="columns is-mobile is-centered">
            <div class="column is-one-half has-text-centered">
                <a @click="$router.push(`/tag/transaction-details/${_nfcId}`)" class="button is-info is-fullwidth">
                    <span class="icon">
                        <i class="fa fa-info-circle"></i>
                    </span>
                    <span>More Details</span>
                </a>
            </div>
          </div>
      </section>
      <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "TagTransactions",
  components: {
    Header,
    Notification,
    NavigationTabs,
    Spinner
  },
  props: {
    _nfcId: String
  },
  mounted: async function()
  {
      try
      {
        this.loading = true;
        const response = await this.$http.get(`/Transactions/Tag/${this._nfcId.toUpperCase()}`);
        
        response.data.transactions.forEach(transaction =>
        {
            let amount = (transaction.credits * this.user.wallet.currency.exchangeRate).toFixed(this.user.wallet.currency.roundToDP);

            if(this.user.wallet.currency.isPrefix)
            {
                amount = this.user.wallet.currency.symbol + amount;
            }

            else
            {
                amount += " " + this.user.wallet.currency.symbol;
            }

            this.transactions.push(
            {
                date: new Date(transaction.movementDt).toLocaleString(),
                amount,
                // description: transaction.description
            });
        });
      }

      catch(error)
        {
            this.$refs.content.scrollTo(0, 0);
            
            if(error.response)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }

        this.loading = false;
  },
  data () {
      return {
          transactions: []
      }
  },
  computed:
  {
      allowedUsers: function()
      {
          return [36, 453, 455, 456, 484].includes(this.user.userID);
      }
  }
};
</script>
